<template>
	<vxe-modal ref="selectmodal" :title="title" :mask="false" :show-zoom="false" :resize="false" :lock-view="true"
		:width="size.width" :height="size.height" :zIndex="2001" :loading="load" >
		<template v-slot:header>
			<div>
				<slot :customerData="chooseOne" name="headerbtn">
					<vxe-button type="text" class="tool-btn _icon_button" title="确定" @click="comfirm">
						<i class="iconfont icon-queding-copy iconSize "></i>确定
					</vxe-button>
				</slot>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" @click="exit">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</div>
		</template>
		<template v-slot>
				<div class="fulldiv model_table">
					<c-table ref="ctable" :table="table" index1="diolog"
					@FitColumns="$emit('FitColumns',$event);"  style="height: calc(100% - 20px);" v-if="!load"
						class="table_height print_selecttable_div" :coltype="mutiselect?'checkbox':'index'" :selectable="selectable" @listenToChild="listenToChild" 
						:colfilter="colfilter"></c-table>
				</div>
		</template>
	</vxe-modal>
	<!-- :visible.sync="dialogVisible" -->
	<!-- <el-dialog ref="selectmodal" :title="title" width="50%" :height="500" :visible.sync="show" :show-close="false">
		<div slot="title" style="text-align: start;">
			<div  class="flex flex_row flex-nowrap">
				<vxe-button type="text" class="tool-btn _icon_button" title="确定" @click="comfirm">
					<i class="iconfont icon-queding-copy iconSize "></i>确定
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" @click="exit">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</div>
		</div>
		<div v-loading="load" style="height: 500px;">
			<div class="fulldiv">
				<c-table ref="ctable" :table="table" style="height: calc(100% - 20px);"
					class="table_height print_selecttable_div" coltype="index" @listenToChild="listenToChild"></c-table>
			</div>
		</div>
		
	</el-dialog> -->
</template>

<script>
	export default {
		props: {
			width:{
				type:[Number,String],
				default:0
			},
			height:{
				type:Number,
				default:0
			},
			table: {
				type: Object,
				default: () => {}
			},
			title: {
				type: String,
				default: '选择' //单选
			},
			load: {
				type: Boolean,
				default: false
			},
			mutiselect:{
				type:Boolean,
				default:false
			},
			selectable:{
				type:Function,
				default:()=>{}
			},
			colfilter:{
				type:Boolean,
				default:false
			},
			autoEixt:{
				type:Boolean,
				default:true
			}
		},
		watch: {
			// table: {
			// 	handler(value,old){
			// 		try{
			// 			if(JSON.stringify(value.data)!=JSON.stringify(old.data)){
			// 				setTimeout(()=>{
			// 					console.log(this.$refs.ctable)
			// 					console.log(value,old)
			// 						if(this.$refs.ctable)
			// 							this.$refs.ctable.updateCoulm();
			// 				},200);
			// 			}
			// 		}catch(e){
			// 			this.$BH().message(e);
			// 		}
					
			// 	},
			// 	deep: true
			// },
		},
		data() {
			return {
				chooseOne: {},
				show:false,
				fullScrent:false
			}
		},
		computed:{
			size(){
				var ar={
					default:{
						width:'45rem',
						height:'25rem'
					},
					full:{
						width:'100%',
						height:'100%'
					}
				};
				if (this.$BH().base.checkString(this.width)) {
					ar.default.width = this.width;
                }else if(this.width)
					ar.default.width=`${this.width}rem`
				if(this.height)
					ar.default.height=`${this.height}rem`
				return this.fullScrent?ar.full:ar.default;
			}
		},
		methods: {
			clearSelection(e){
				if(this.$refs.ctable)
					this.$refs.ctable.clearSelection(e);
			},
			changeColumn(){
				// console.log('---changecolumn',this.$refs.ctable)
				if(this.$refs.ctable)
					this.$refs.ctable.checkColumnChange();
			},
			exit() {
				if (this.$refs.selectmodal) this.$refs.selectmodal.close();
				this.clearSelection();//清除选择表格中的选择
				this.$emit('clear',[]);
				this.show=false;
			},
			open() {
				// console.log(this.load)
				this.fullScrent=false;
				if (this.$refs.selectmodal) this.$refs.selectmodal.open();
				this.show=true;
				this.chooseOne={};
			},
			openFull(){
				this.open();
				this.fullScrent=true;
			},
			listenToChild(e) {
				this.$emit('listenToChild',e)
				if (e && e['rowClick']) {
					this.chooseOne = e.rowClick;
				}else if(e && e['rowdbClick']&&!this.mutiselect){
					this.chooseOne = e.rowdbClick;
					this.comfirm();
				}else if(e&&e['checkList']){
					this.chooseOne = e;
				}if(e&&e['sizeChange']) this.table.pagesize=e['sizeChange'];
			},
			comfirm() {
				this.$emit('confirm', this.chooseOne);
				if(this.autoEixt)
					this.exit()
			}
		},
		mounted() {
		}
	}
</script>

<style lang="scss">
	$color_white:#fff;
	.model_table{
		.cell{
			line-height: 1rem;
		}
		th{
			text-align: center;
			padding:8px 0px;
		}
		td{
			padding: 10px 0;
		}
		.el-pagination{
			// padding-top: 10px;
			text-align: end;
			.btn-prev,.btn-next{
				background-color: $color_white;
			}
			.el-pagination__jump{
				margin-left: 0px;
			}
		}
	}
</style>
